import { Pressable } from "react-native";

import { Text } from "@/components/ui/text";
import { cn } from "@/lib/utils";

type FilterChipProps = {
    label: string;
    selected: boolean;
    onPress: () => void;
    testID?: string;
};

export function FilterChip({
    label,
    selected,
    onPress,
    testID,
}: FilterChipProps) {
    return (
        <Pressable
            accessibilityRole="button"
            accessibilityState={{ selected }}
            accessibilityLabel={label}
            onPress={onPress}
            testID={testID}
            className={cn(
                "shrink-0 self-start rounded-full border px-2 py-1.5",
                selected
                    ? "border-primary bg-primary"
                    : "border-border bg-card active:bg-accent",
            )}
        >
            <Text
                className={cn(
                    "font-sans-medium text-xs tracking-wide",
                    selected ? "text-primary-foreground" : "text-foreground",
                )}
            >
                {label}
            </Text>
        </Pressable>
    );
}
